import {Observable} from 'rxjs';
import {RestQueryParams} from './base/queryParams';
import {jobHunterAPI} from './provider/jobHunterAPI';

export function confirmRegistrationAPI(authToken: string): Observable<any> {
    return jobHunterAPI.post(
        `api/users/confirm_registration`,
        {},
        new RestQueryParams(),
        {
            'X-Authentication-Token': authToken
        }
    );
}
